'use client';
import * as S from './styles.ts';
import { Button } from '@template/components';
import ArchStandaloneSectionComponent from '@template/blocks/ArchStandaloneSection/component';

interface CTASectionComponentProps {
  heading?: string;
  subHeading?: string;
  buttonText?: string;
  buttonLink?: string;
  target?: '_blank';
}

const CTASectionComponent = ({
  heading,
  buttonText,
  buttonLink,
  subHeading,
  target,
}: CTASectionComponentProps) => {
  return (
    <S.CTAWrapper>
      <ArchStandaloneSectionComponent
        color='grey'
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
        }}
      />
      <S.CTAContainer>
        {(heading || subHeading) && (
          <S.CTATextContainer>
            {heading && <S.CTAHeadline>{heading}</S.CTAHeadline>}
            {subHeading && <S.CTAText>{subHeading}</S.CTAText>}
          </S.CTATextContainer>
        )}
        {buttonText && (
          <Button size='lg' navigation={{ target, href: buttonLink }}>
            {buttonText}
          </Button>
        )}
      </S.CTAContainer>
    </S.CTAWrapper>
  );
};

export default CTASectionComponent;

export const options = [
  {
    description: '',
    displayName: 'CTASectionComponent',
    methods: [],
    props: {
      heading: {
        required: false,
        flowType: { name: 'string' },
        description: '',
      },
      subHeading: {
        required: false,
        flowType: { name: 'string' },
        description: '',
      },
      buttonText: {
        required: false,
        flowType: { name: 'string' },
        description: '',
      },
      buttonLink: {
        required: false,
        flowType: { name: 'string' },
        description: '',
      },
      target: {
        required: false,
        flowType: { name: 'literal', value: '"_blank"' },
        description: '',
      },
    },
  },
];
